export default defineNuxtPlugin(() => {
  // Глобальная обработка ошибок
  if (process.client) {
    // Обработка ошибок JavaScript
    window.addEventListener('error', (event) => {
      console.error('JavaScript Error:', event.error)
      // Предотвращаем вывод ошибки в консоль для production
      if (process.env.NODE_ENV === 'production') {
        event.preventDefault()
      }
    })
    
    // Обработка необработанных промисов
    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled Promise Rejection:', event.reason)
      // Предотвращаем вывод ошибки в консоль для production
      if (process.env.NODE_ENV === 'production') {
        event.preventDefault()
      }
    })
    
    // Обработка ошибок загрузки ресурсов
    window.addEventListener('error', (event) => {
      if (event.target !== window) {
        console.error('Resource loading error:', event.target)
        // Предотвращаем вывод ошибки в консоль для production
        if (process.env.NODE_ENV === 'production') {
          event.preventDefault()
        }
      }
    }, true)
    
    // Очистка консоли от лишних сообщений
    if (process.env.NODE_ENV === 'production') {
      console.clear = () => {} // Отключаем очистку консоли в production
    }
  }
  
  // Обработка ошибок на сервере
  if (process.server) {
    // Увеличиваем лимит слушателей для процесса
    process.setMaxListeners(20)
    
    // Проверяем, не зарегистрированы ли уже слушатели
    const existingListeners = process.listeners('uncaughtException').length
    const existingRejectionListeners = process.listeners('unhandledRejection').length
    
    // Логирование ошибок сервера (только если слушатели еще не зарегистрированы)
    if (existingListeners === 0) {
      process.on('uncaughtException', (error) => {
        console.error('Uncaught Exception:', error)
      })
    }
    
    if (existingRejectionListeners === 0) {
      process.on('unhandledRejection', (reason) => {
        console.error('Unhandled Rejection:', reason)
      })
    }
  }
})
